import React from 'react';

import { ReactComponent as AddAnswerSvg } from '../../../assets/add_answer.svg';
import { QuestionDetailsFragment, useGetQuestionDetailsQuery } from '../../../graphql/gen/types';
import { ButtonColor, PlexButton } from '../../shared/primitives/PlexButton';
import { useDialogState } from '../dialog/useDialogState';
import { canCreateAnswer } from '../permissions';

interface Props {
  className?: string;
  question: QuestionDetailsFragment;
}

export const NewAnswerButton = ({ question, className }: Props): React.ReactElement => {
  const [, setDialogState] = useDialogState();
  const { id } = question;
  const plexRelation = question.plex.currentUserRelation.state;

  const handleClickOpen = (): void => {
    setDialogState({ type: 'new_fact_answer', factId: id });
  };

  const disabledReason = ((): string | undefined => {
    if (!canCreateAnswer({ plexRelation })) {
      return 'You do not have access to add answers to this Fact';
    }

    return undefined;
  })();

  return (
    <PlexButton
      disabled={disabledReason != null}
      className={className}
      onClick={handleClickOpen}
      label="Add Answer"
      SvgIconRight={AddAnswerSvg}
      color={ButtonColor.Primary}
      tooltip={disabledReason}
    />
  );
};

export const NewAnswerButtonContainer = ({
  factId,
  className,
}: {
  factId: string;
  className?: string;
}): React.ReactElement | null => {
  const { data } = useGetQuestionDetailsQuery({ variables: { questionId: factId } });

  if (data?.loggedIn?.questionById == null) {
    return null;
  }

  return <NewAnswerButton question={data.loggedIn.questionById} className={className} />;
};
